'use strict';
angular
    .module('dnapp')
    .directive('loading', ['$http', function ($http) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                scope.isLoading = function () {
                    //console.log('isRedirecting:' + elm.context.attributes.isredirecting);
                    return $http.pendingRequests.length > 0 || elm.context.attributes.isredirecting != null;
                };
                scope.$watch(scope.isLoading, function (v) {
                    if (v) {
                        elm.show();
                    } else {
                        elm.hide();
                    }
                });
            }
        };
    }]);